(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('reviewRemoveAction', {
      controller: Controller,
      templateUrl: 'actions/review/remove/remove-review.action.html',
      bindings: {
        reviewId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
